import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface IProps {
  onClose: () => void;
  errorMessage: string;
  onClick?: () => void;
  onBack?: () => void;
  isConnectionSelected?: boolean;
}

export const ConnectionFailedSection = ({ 
  onClose, 
  errorMessage, 
  onClick, 
  onBack, 
  isConnectionSelected 
}: IProps) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full px-5 pt-5 pb-5">
      <X
        size={13}
        className="cursor-pointer self-end text-muted-foreground hover:text-foreground transition-colors duration-150"
        style={{ width: '13px', height: '13px', minWidth: '13px', minHeight: '13px' }}
        onClick={onClose}
      />

      <div className="flex flex-col w-full h-full gap-6 items-center justify-center">
        {/* Error icon */}
        <div className="w-14 h-14 rounded-full bg-red-500 flex items-center justify-center shadow-sm">
          <svg 
            className="w-7 h-7 text-white" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor" 
            strokeWidth={2}
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" 
            />
          </svg>
        </div>

        {/* Error message */}
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-lg font-semibold tracking-tight">
            Connection failed
          </h1>
          <p className="text-sm text-muted-foreground text-center max-w-[280px] leading-relaxed">
            {errorMessage}
          </p>
        </div>

        {onClick && (
          <Button 
            className="w-full" 
            onClick={isConnectionSelected ? onClose : onBack}
          >
            {isConnectionSelected ? "Close window" : "Try again"}
          </Button>
        )}
      </div>
    </div>
  );
};
